import { render } from "./MyPerfil.vue?vue&type=template&id=0e4a214a&scoped=true&ts=true"
import script from "./MyPerfil.vue?vue&type=script&lang=ts"
export * from "./MyPerfil.vue?vue&type=script&lang=ts"

import "./MyPerfil.vue?vue&type=style&index=0&id=0e4a214a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4a214a"]])

export default __exports__